import App from "../app";

require('publicPath');
var app = new App();